import React from 'react';
import { useSelector } from 'react-redux';
import { ModalStage } from '../../store/modalSlice';
import ModalInitial from '../../components/modalcontent/ModalInitial';
import CreateNewEth from '../../components/modalcontent/CreateNewEth';
import ConnectNewEth from '../../components/modalcontent/ConnectNewEth';
import ConnectSuccesEth from '../../components/modalcontent/ConnectSuccesEth';
import PublicMint from '../../components/modalcontent/PublicMint';
import ConnectOldEth from '../../components/modalcontent/ConnectOldEth';
import OgStatus from '../../components/modalcontent/OgStatus';
import OgNotEligible from '../../components/modalcontent/OgNotEligible';
import OgMint from '../../components/modalcontent/OgMint';
import Finish from '../../components/modalcontent/Finish';

const ModalContent = () => {
    const stageModal = useSelector(state => state.modal.stage);
    switch (stageModal) {
        case ModalStage.CREATE_NEW_ETH:
            return <CreateNewEth />;
        case ModalStage.CONNECT_NEW_ETH:
            return <ConnectNewEth />;
        case ModalStage.SUCCESS_NEW_ETH:
            return <ConnectSuccesEth />;
        case ModalStage.PUBLIC_MINT:
            return <PublicMint />;
        case ModalStage.OG_CONNECT:
            return <ConnectOldEth />;
        case ModalStage.OG_STATUS:
            return <OgStatus />;
        case ModalStage.OG_NOT_ELIGIBLE:
            return <OgNotEligible />;
        case ModalStage.OG_MINT:
            return <OgMint />;
        case ModalStage.FINISH_X:
            return <Finish />;
        default:
            return <ModalInitial />;
    }
};

export default ModalContent;
